/**
 * Bold Subscriptions — Dynamic Main Price Update
 *
 * Syncs the main product price (below the title) with the BOLD
 * subscription widget selection. Shows the discounted subscription
 * price when "Subscribe and Save" is selected, and reverts to the
 * regular price for "One-time Purchase".
 *
 * Installation: Add to Shopify theme via Online Store > Themes >
 * Edit Code > Assets > Add new asset > bold-price-sync.js
 * Then include in product template (see instructions below).
 */
(function () {
  'use strict';

  function init() {
    var BOLD = window.BOLD;
    if (!BOLD || !BOLD.BsubWidget) return;

    var bsub = BOLD.BsubWidget;
    var priceBlock = document.querySelector('[data-block-id="price"]');
    if (!priceBlock) return;

    var priceContainer = priceBlock.querySelector('.price');
    var regularDiv = priceBlock.querySelector('.price__regular');
    var saleDiv = priceBlock.querySelector('.price__sale');
    if (!priceContainer || !regularDiv || !saleDiv) return;

    var regularPriceEl = regularDiv.querySelector('.price-item--regular.wt-product__price__final');
    var salePriceEl = saleDiv.querySelector('.price-item--sale.wt-product__price__final');
    var compareAtEl = saleDiv.querySelector('.wt-product__price__compare');

    function getCurrentVariantId() {
      var input = document.querySelector('form[action="/cart/add"] input[name="id"]');
      return input ? input.value : Object.keys(bsub.variants)[0];
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getSelectedAllocation(variant) {
      var planInput = document.querySelector('input[name="selling_plan"]');
      if (!planInput || !planInput.value) return null;

      var planId = parseInt(planInput.value, 10);
      var allocations = variant.selling_plan_allocations || [];
      for (var i = 0; i < allocations.length; i++) {
        if (allocations[i].selling_plan_id === planId) return allocations[i];
      }
      return allocations[0] || null;
    }

    function updateMainPrice() {
      var groupRadio = document.querySelector('[name="bsub-selling-plan-group"]:checked');
      if (!groupRadio) return;

      var variant = bsub.variants[getCurrentVariantId()];
      if (!variant) return;

      var isSubscription = groupRadio.value !== 'once';

      if (isSubscription) {
        var allocation = getSelectedAllocation(variant);
        if (!allocation) return;

        // Show sale layout: subscription price + strikethrough original
        regularDiv.style.display = 'none';
        saleDiv.style.display = 'flex';
        priceContainer.classList.add('price--on-sale');

        if (salePriceEl) salePriceEl.textContent = formatMoney(allocation.per_delivery_price);
        if (compareAtEl) {
          compareAtEl.textContent = formatMoney(variant.price);
          compareAtEl.classList.remove('hidden');
          compareAtEl.style.display = '';
        }
      } else {
        // Show regular layout: original price only
        regularDiv.style.display = 'block';
        saleDiv.style.display = 'none';
        priceContainer.classList.remove('price--on-sale');

        if (regularPriceEl) regularPriceEl.textContent = formatMoney(variant.price);
      }
    }

    // Listen for one-time vs subscribe toggle
    var groupRadios = document.querySelectorAll('[name="bsub-selling-plan-group"]');
    groupRadios.forEach(function (radio) {
      radio.addEventListener('change', updateMainPrice);
    });

    // Listen for frequency option changes (30/45/60 days)
    var optionRadios = document.querySelectorAll('[data-bsub-selling-plan-option-input]');
    optionRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        // Small delay so BOLD can update the hidden selling_plan input first
        setTimeout(updateMainPrice, 50);
      });
    });

    // Also observe the hidden selling_plan input for programmatic changes
    var planInputs = document.querySelectorAll('input[name="selling_plan"]');
    if (planInputs.length) {
      var observer = new MutationObserver(function () {
        setTimeout(updateMainPrice, 50);
      });
      planInputs.forEach(function (input) {
        observer.observe(input, { attributes: true, attributeFilter: ['value'] });
      });
    }

    // Run on load (handles default_subscribe: true)
    updateMainPrice();
  }

  // Wait for page + BOLD widget to fully initialize
  function waitForBold() {
    if (window.BOLD && window.BOLD.BsubWidget && window.BOLD.BsubWidget.variants) {
      init();
    } else {
      setTimeout(waitForBold, 200);
    }
  }

  if (document.readyState === 'complete') {
    waitForBold();
  } else {
    window.addEventListener('load', waitForBold);
  }
})();
